
import React from 'react';

const SidebarFooterSection = () => {
  return (
    <div className="px-3 py-2">
      <div className="rounded-md bg-primary/10 px-3 py-2 text-center text-xs">
        <p className="text-primary">PetDocument v1.0</p>
      </div>
    </div>
  );
};

export default SidebarFooterSection;
